module.exports = __webpack_public_path__ + "static/media/MIAB9919-180731-129_Small.8b5b9808.jpg";